/**
 * Bundle Page Skeleton
 * Skeleton screen for Bundle.jsx page
 * Shows bundle header + template cards
 */

import React from 'react';
import { Box, Grid, Card, CardContent } from '@mui/material';
import SkeletonBase, { SkeletonText, SkeletonButton, SkeletonCard } from './SkeletonBase';
import { spacing } from '../../theme/tokens';

/**
 * Single Template Card Skeleton
 */
function TemplateCardSkeleton() {
  return (
    <Card sx={{ padding: spacing.md }}>
      <CardContent>
        <SkeletonText size="lg" width="80%" />
        <SkeletonText size="md" width="60%" sx={{ marginTop: spacing.sm }} />
        <SkeletonText size="sm" width="40%" sx={{ marginTop: spacing.xs }} />

        <Box sx={{ marginTop: spacing.lg }}>
          <SkeletonButton width="100%" />
        </Box>
      </CardContent>
    </Card>
  );
}

/**
 * Bundle Page Skeleton
 *
 * @param {Object} props
 * @param {number} props.templateCount - Number of template cards (default: 3)
 */
export default function BundleSkeleton({ templateCount = 3 }) {
  return (
    <Box sx={{ padding: spacing.lg }}>
      {/* Bundle Header */}
      <Box sx={{ marginBottom: spacing.xl }}>
        <SkeletonText size="xl" width="50%" />
        <SkeletonText size="md" width="70%" sx={{ marginTop: spacing.sm }} />
      </Box>

      {/* Progress indicator */}
      <Box sx={{ marginBottom: spacing.lg }}>
        <SkeletonBase variant="rounded" height={60} />
      </Box>

      {/* Template Cards */}
      <Grid container spacing={3}>
        {Array.from({ length: templateCount }).map((_, index) => (
          <Grid item xs={12} md={6} lg={4} key={`template-skeleton-${index}`}>
            <TemplateCardSkeleton />
          </Grid>
        ))}
      </Grid>

      {/* Action Buttons */}
      <Box sx={{ display: 'flex', gap: spacing.md, marginTop: spacing.xl, justifyContent: 'center' }}>
        <SkeletonButton width={120} />
        <SkeletonButton width={150} />
      </Box>
    </Box>
  );
}
